import { CapacitorHttp } from "@capacitor/core";
import type { AccessToken } from "@/generated-api/models/AccessToken";
import type { EmailOtpCodeFingerprintPayload } from "@/generated-api/models/EmailOtpCodeFingerprintPayload";
import type { TokenPayload } from "@/generated-api/models/TokenPayload";
import { OpenAPI } from "@/generated-api/core/OpenAPI";

class NativeAuthError extends Error {
  constructor(public readonly status: number) {
    super(`Auth request failed: ${status}`);
  }
}

const post = async <T>(path: string, body?: unknown): Promise<T> => {
  const response = await CapacitorHttp.request({
    method: "POST",
    url: `${OpenAPI.BASE}${path}`,
    headers: {
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...(OpenAPI.HEADERS as Record<string, string> | undefined),
    },
    data: body,
  });
  if (response.status < 200 || response.status >= 300) {
    throw new NativeAuthError(response.status);
  }
  return response.data as T;
};

export const nativeLogout = (): Promise<void> =>
  post("/api/auth/logout", undefined);

export const nativeCompleteLogin = (
  data: EmailOtpCodeFingerprintPayload,
): Promise<AccessToken> => post("/api/public/auth/complete-login", data);

export const nativeGoogleLogin = (
  data: TokenPayload,
): Promise<AccessToken> => post("/api/public/auth/google-login", data);

export const nativeAppleLogin = (
  data: TokenPayload,
): Promise<AccessToken> => post("/api/public/auth/apple-login", data);
